import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../shared/shared.module';
import { EncuestaResponderComponent } from './encuesta-responder/encuesta-responder.component';
import { SubscribirseComponent } from './subscribirse/subscribirse.component';

@NgModule({
    imports: [
        SharedModule,
        // RouterModule.forChild(routes)
    ],
    declarations: [
        EncuestaResponderComponent,
        SubscribirseComponent,
    ],
    exports: [
        RouterModule,
        EncuestaResponderComponent,

    ]
})
export class EncuestaResponderModule { }



// WEBPACK FOOTER //
// ./src/app/routes/encuesta/encuesta.module.ts